function normalizeTeamId(value) {
  return typeof value === "string" && value.trim().length > 0
    ? value.trim()
    : null;
}

export function getRequestedTeamId(search = "") {
  try {
    const params = new URLSearchParams(search || "");
    return normalizeTeamId(params.get("teamId"));
  } catch (_) {
    return null;
  }
}

export function buildTeamScopedPath(path, teamId) {
  const normalizedPath =
    typeof path === "string" && path.trim().length > 0 ? path.trim() : "/";
  const normalizedTeamId = normalizeTeamId(teamId);

  if (!normalizedTeamId) {
    return normalizedPath;
  }

  const [pathname, hash = ""] = normalizedPath.split("#");
  const [basePath, rawSearch = ""] = pathname.split("?");
  const params = new URLSearchParams(rawSearch);
  params.set("teamId", normalizedTeamId);

  const nextSearch = params.toString();
  const nextPath = nextSearch ? `${basePath}?${nextSearch}` : basePath;

  return hash ? `${nextPath}#${hash}` : nextPath;
}
